import { useCallback, useState, type ReactNode } from 'react'
import { getPageSource } from '@mc/track-event'
import { useTrackEmailCaptured } from '../../libs/client/marketing/useTrackEmailCaptured'

import ThankYou from './ThankYou'
import EmailForm from './EmailForm'

import classes from './EmailCapture.module.scss'

type TrackProps = {
  campaign?: string
  location?: string
  contentType?: string
  slug?: string
  category?: string
}

type EmailCaptureProps = {
  className?: string
  trackProps?: TrackProps
  thankYouText?: string
  children?: ReactNode
  buttonType?: 'primary' | 'secondary' | 'tertiary'
}

const EmailCapture = ({
  className = 'mc-theme-dark mc-bg-dark',
  trackProps,
  thankYouText,
  children,
  ...props
}: EmailCaptureProps) => {
  const [success, setSuccess] = useState(false)
  const trackEmailCaptured = useTrackEmailCaptured()

  const handleSubmit = useCallback(
    async ({ email }: { email: string }) => {
      await trackEmailCaptured({
        event: 'Email Captured',
        properties: {
          campaign: trackProps?.campaign || 'sample',
          email,
          location: trackProps?.location,
          content_type: trackProps?.contentType,
          slug: trackProps?.slug,
          type: 'email',
          platform: 'web',
          category: trackProps?.category,
          page_source: getPageSource(),
        },
        integrations: { Iterable: true },
      })
      setSuccess(true)
    },
    [trackEmailCaptured, trackProps],
  )

  return (
    <section
      className='container mc-my-12 mc-pt-4 position-relative'
      data-testid='email-capture'
      id='email-capture'
    >
      <div className={className}>
        <div
          className={`position-absolute ${classes.thankYou} ${
            !success && classes.hidden
          }`}
        >
          <ThankYou descriptionText={thankYouText} />
        </div>
        <div className={success ? classes.hidden : ''}>
          <EmailForm onSubmit={handleSubmit} {...props}>
            {children as React.ReactElement}
          </EmailForm>
        </div>
      </div>
    </section>
  )
}

export default EmailCapture
